import { format } from "date-fns";
import { type Call as CallResponse } from "../api";
import { Utility } from "./utility";

export interface Call extends CallResponse {
  get_local_time(time_string: string): Date;
}

export class Call extends Utility<Call> {
  constructor(init?: Partial<CallResponse>) {
    super();
    Object.assign(this, init);
  }

  get local_created_at(): Date | undefined {
    if (this.created_at === undefined) return undefined;
    return this.get_local_time(this.created_at);
  }

  get local_updated_at(): Date | undefined {
    if (this.updated_at === undefined) return undefined;
    return this.get_local_time(this.updated_at);
  }

  get local_created_at_string(): string {
    if (!this.local_created_at) return "";
    return format(this.local_created_at, "MMM dd, yyyy hh:mm aa");
  }

  get local_updated_at_string(): string {
    if (!this.local_updated_at) return "";
    return format(this.local_updated_at, "MMM dd, yyyy hh:mm aa");
  }
}
